import ChangeEmailProcess from './change-email-process';

export default ChangeEmailProcess;
export {  SECOND_STEP, THIRD_STEP } from './change-email-process';